import { Path } from "../routes/PagePath";
import { Link } from "react-router-dom";

type Props = {
    answererId: string;
    children: React.ReactNode;
};

export const AddQuestionLink = (props: Props) => {
    const { answererId, children } = props;
    return (
        <p className="mx-3 mt-6 text-right text-xs underline">
            <Link
                to={`${Path.addQuestion}/${answererId}`}
                className="text-primary"
            >
                {children}
            </Link>
        </p>
    );
};
